import { useRef, useState, useEffect } from 'react'
import styles from './scrollable-container.module.css'

export interface ScrollableContainerProps {
  description?: string
  children: React.ReactNode
}

export function ScrollableContainer({
  description,
  children,
}: ScrollableContainerProps) {
  const containerRef = useRef<HTMLDivElement>(null)
  const [hasOverflow, setHasOverflow] = useState(false)

  useEffect(() => {
    const container = containerRef.current

    if (!container) return

    const checkOverflow = () => {
      setHasOverflow(container.scrollWidth > container.clientWidth)
    }

    checkOverflow()

    const observer = new ResizeObserver(checkOverflow)
    observer.observe(container)

    return () => observer.disconnect()
  }, [])

  return (
    <div>
      <div ref={containerRef} className={styles.scrollableContainer}>
        <div className={styles.content}>{children}</div>
      </div>
      {hasOverflow && description && (
        <span className={styles.description}>{description}</span>
      )}
    </div>
  )
}
